// extracted by mini-css-extract-plugin
module.exports = {"link":"SortableHeader__link___2_rPB","active":"SortableHeader__active___7HXEM"};